import React, { useEffect, useState, useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Loading from 'custom/assets/loaders/Loading'
import { useModal } from 'react-modal-hook'
import Modal from '../../components/Modal/Modal'
import NeoButton from '../../components/NeoButton/NeoButton'
import { useTranslation } from 'react-i18next'
import Pagination from 'react-js-pagination'
import AddIcon from 'custom/assets/common-icons/Add.svg'
import { useHistory, useLocation } from 'react-router-dom'
import { Col, Row } from 'react-bootstrap'
import NumberFormat from 'react-number-format'
import LayoutWithOutAccountCard from '../Layout/layout-without-card'
import RequestService from '../../services/request.service'
import { getRoleAccessKeySelector, getMenuListSelector } from '../../store/selectors/app.selector'
import { BUTTON_KEYS, STANDING_INSTRUCTION_KEYS } from '../../utils/translation-constants'

export default function StandingInstruction() {
  const history = useHistory()
  const location = useLocation()
  const [stage, setStage] = useState(1)
  const roleAccessKey = useSelector(getRoleAccessKeySelector)
  const [message, setMessage] = useState()
  const [noRecords, setNoRecords] = useState(false)
  const [loading, setLoading] = useState(false)
  const [siList, setSiList] = useState([])
  const [currentPage, setCurrentPage] = useState(1)
  const pageLimit = 10
  const [slicedDetailStatementList, setSlicedDetailStatementList] = useState([])
  const { t } = useTranslation()
  const menuConfig = useSelector(getMenuListSelector)['SI'] || {}
  const [data, setData] = useState({ url: '', breadCrumb: '' })

  const [showModal, hideModal] = useModal(
    () => (
      <Modal>
        <div className='modal-error-body'>
          <h6>{message?.message}</h6>
          <div className='modal-btn-style'>
            <NeoButton
              tabIndex='1'
              mode='newDesign'
              type='button'
              text={t(BUTTON_KEYS.OK)}
              onClick={() => {
                hideModal()
              }}
            />
          </div>
        </div>
      </Modal>
    ),
    [message],
  )

  const sliceDetailedStatement = useCallback(async (currentPageNo, lst) => {
    // useEffect (  () => {
    setCurrentPage(currentPageNo)
    let start = (currentPageNo - 1) * pageLimit
    let end = currentPageNo * pageLimit
    if (lst && lst.length > 0) {
      let x = lst.slice(start, end < lst.length ? end : lst.length)
      setSlicedDetailStatementList(x)
    }
  }, [])

  const getSIAccounts = useCallback(async () => {
    try {
      setLoading(true)
      const response = await RequestService.getSIList({})
      if (response.status === 200) {
        response.data['siList'].forEach((element) => {
          element.isActive = false
        })
        setSiList(response.data['siList'])
        sliceDetailedStatement(1, response.data['siList'])
        setNoRecords(response.data['siList'].length > 0 ? false : true)
        setLoading(false)
      }
    } catch (err) {
      // setMessage(err.data.message)
      setLoading(false)
      // //showModal()
    }
  }, [])

  useEffect(() => {
    getSIAccounts()
    location.pathname.includes('/requests') &&
      setData({ url: '/requests', breadCrumb: 'REQUESTS_SI' })
    location.pathname.includes('/accounts') &&
      setData({ url: '/accounts', breadCrumb: 'ACCOUNTS_SI' })
  }, [])

  function renderLoading() {
    return (
      <div className='mx-4 rounded d-flex justify-content-center align-items-center'>
        <Loading width='50px' height='50px' />
      </div>
    )
  }

  const getSiDetails = useCallback(
    (selected) => {
      try {
        const siListCopy = [...siList]

        if (selected.isActive === true) {
          siListCopy.forEach((element) => {
            element.isActive = false
          })
          setSiList(siListCopy)
          return
        }

        siListCopy.forEach((ele) => {
          if (ele.contractRefNumber === selected.contractRefNumber) {
            ele.isActive = true
          } else {
            ele.isActive = false
          }
        })
        setSiList(siListCopy)
      } catch (err) {}
    },
    [siList],
  )

  return (
    <LayoutWithOutAccountCard breadCumKey={data.breadCrumb} showEmptySpace={true} keyPath={'SI'}>
      <div className='row'>
        <div className='col-7 d-flex'>
          <div className='heading-style' style={{ margin: 0 }}>
            {t(STANDING_INSTRUCTION_KEYS.TITLE)}
          </div>
        </div>
        {menuConfig['createSi'] && (
          <div className='col-5 text-right'>
            {(roleAccessKey === 'I' || roleAccessKey === 'AA') && (
              <button
                tabIndex={'1'}
                style={{ padding: '5px 20px' }}
                onClick={() => history.push(`${data.url}/standing-instruction/create`)}
                type='button'
                className='btn detailed-statement-btn'>
                <img className='si-icon' src={AddIcon} />
                <span className='font-weight-600'>{t(STANDING_INSTRUCTION_KEYS.CREATE_SI)}</span>
              </button>
            )}
          </div>
        )}
      </div>
      {loading && renderLoading()}
      <div style={{ marginTop: 30 }}>
        {slicedDetailStatementList.map((option, index) => (
          <>
            <div onClick={() => getSiDetails(option)} key={index} className='loan-card '>
              <div className='loan-header'>
                <span>{t(STANDING_INSTRUCTION_KEYS.REFERENCE_NO)}</span>
                <span>{option?.contractRefNumber}</span>
              </div>
              {option.isActive && (
                <div className='loan-details si-card'>
                  <Row>
                    <Col xs={4} sm={4} md={4}>
                      <label>{t(STANDING_INSTRUCTION_KEYS.CONTRACT_REF_NO)}</label>
                      <span>{option?.contractRefNumber || '-'}</span>
                    </Col>

                    <Col xs={4} sm={4} md={4}>
                      <label>{t(STANDING_INSTRUCTION_KEYS.SOURCE_ACCOUNT)}</label>
                      <span>{option?.srcaccount || '-'}</span>
                    </Col>

                    <Col xs={4} sm={4} md={4}>
                      <label>{t(STANDING_INSTRUCTION_KEYS.BENEFICIARY_ACCOUNT)}</label>
                      <span>{option?.beneficiaryAccount || '-'}</span>
                    </Col>
                    <Col xs={4} sm={4} md={4}>
                      <label>{t(STANDING_INSTRUCTION_KEYS.BRANCH_CODE)}</label>
                      <span>{option?.branchCode || '-'}</span>
                    </Col>

                    <Col xs={4} sm={4} md={4}>
                      <label>{t(STANDING_INSTRUCTION_KEYS.CURRENCY)}</label>
                      <span>{option?.currency || '-'}</span>
                    </Col>

                    <Col xs={4} sm={4} md={4}>
                      <label>{t(STANDING_INSTRUCTION_KEYS.AMOUNT)}</label>
                      <NumberFormat
                        value={option?.amount}
                        displayType={'text'}
                        thousandSeparator={true}
                        prefix={''}
                        fixedDecimalScale={true}
                        decimalScale={2}
                        allowEmptyFormatting
                      />
                    </Col>

                    <Col xs={4} sm={4} md={4}>
                      <label>{t(STANDING_INSTRUCTION_KEYS.CYCLE_START_DATE)}</label>
                      <span>{option?.cyclestartDate || '-'}</span>
                    </Col>

                    <Col xs={4} sm={4} md={4}>
                      <label>{t(STANDING_INSTRUCTION_KEYS.EXPIRY_DATE)}</label>
                      <span>{option?.expiryDate || '-'}</span>
                    </Col>

                    <Col xs={4} sm={4} md={4}>
                      <label>{t(STANDING_INSTRUCTION_KEYS.STATUS)}</label>
                      <span>{option?.status || '-'}</span>
                    </Col>

                    <Col xs={12} sm={12} md={12}>
                      <label>{t(STANDING_INSTRUCTION_KEYS.REMARKS)}</label>
                      <span>{option?.remarks || '-'}</span>
                    </Col>
                  </Row>
                </div>
              )}
            </div>
          </>
        ))}
      </div>
      {noRecords && <div className='no-data-found'>{t(STANDING_INSTRUCTION_KEYS.NO_RECORDS)}</div>}
      <br />
      {siList.length > 0 && siList.length > 10 ? (
        <div className='d-flex justify-content-center mb-5 mt-2'>
          {loading ? null : (
            <Pagination
              activePage={currentPage}
              itemsCountPerPage={10}
              totalItemsCount={siList.length}
              pageRangeDisplayed={5}
              itemClass='page-item'
              linkClass='page-link'
              onChange={(page) => sliceDetailedStatement(page, siList)}
            />
          )}
        </div>
      ) : null}
    </LayoutWithOutAccountCard>
  )
}
